
export default function Benefits() {
  const benefits = [
    {
      icon: '✓',
      title: '검증된 업체만',
      description: '철저한 검증 시스템을 통해 안전하고 신뢰할 수 있는 업체만을 소개합니다. 당신의 안전이 최우선입니다.',
      color: 'from-[#EDE9FE] to-[#DDD6FE]',
      iconBg: 'bg-[#8B5CF6]'
    },
    {
      icon: '⚡',
      title: '빠른 급여 지급',
      description: '근무 후 신속한 급여 지급 시스템으로 당신의 시간을 존중합니다. 주급, 일급 모두 가능합니다.',
      color: 'from-[#F3E8FF] to-[#E9D5FF]',
      iconBg: 'bg-[#A855F7]'
    },
    {
      icon: '💬',
      title: '24시간 고객지원',
      description: '언제든지 문의하세요. 전문 상담팀이 24시간 대기하여 당신의 문제를 신속하게 해결해드립니다.',
      color: 'from-[#FAE8FF] to-[#F5D0FE]',
      iconBg: 'bg-[#C026D3]'
    }
  ];

  return (
    <section id="benefits" className="py-16 sm:py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2332] text-center mb-10 md:mb-20">
          온니잡만의 특별함
        </h2>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl md:rounded-3xl overflow-hidden hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl cursor-pointer group"
            >
              <div className={`h-36 sm:h-40 md:h-48 bg-gradient-to-br ${benefit.color} flex items-center justify-center`}>
                <img
                  src={`https://public.readdy.ai/ai/img_res/710a3773f766260fd9f598abba36e3e5.jpg$%7Bbenefit.title%7D%20modern%20minimalist%20pastel%20purple%20lavender%20colors%20simple%20clean%20design%20professional%20business%20concept%20korean%20job%20platform&width=400&height=300&seq=benefit${index + 1}v2&orientation=landscape`}
                  alt={benefit.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-5 sm:p-6 md:p-8">
                <div className={`w-10 h-10 md:w-12 md:h-12 ${benefit.iconBg} rounded-xl md:rounded-2xl flex items-center justify-center text-white text-xl md:text-2xl mb-3 md:mb-4 group-hover:scale-110 transition-transform`}>
                  {benefit.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-[#1A2332] mb-2 md:mb-3">
                  {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
